import React from "react";

/**
 * Smart Table brand mark.
 * Renders "Smart" in white + "Table" in teal with subtle arc accent, "by renova360" subtitle.
 */
export const Brand = ({ size = "md", showSubtitle = true, className = "" }) => {
    const scales = {
        sm: { title: "text-base", sub: "text-[8px]", arc: 18 },
        md: { title: "text-xl", sub: "text-[9px]", arc: 22 },
        lg: { title: "text-3xl", sub: "text-[11px]", arc: 32 },
        xl: { title: "text-4xl xl:text-5xl", sub: "text-xs", arc: 44 },
    };
    const s = scales[size] || scales.md;
    return (
        <div className={`inline-flex flex-col items-start ${className}`} data-testid="brand-logo">
            <div className={`flex items-baseline gap-1 font-display font-bold ${s.title} tracking-tight leading-none relative`}>
                <span className="text-white">Smart</span>
                <span className="text-brand">Table</span>
                <svg
                    viewBox="0 0 80 30"
                    width={s.arc * 2.6}
                    height={s.arc}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    className="text-brand absolute -right-2 -top-1 -z-0 opacity-70 pointer-events-none"
                    aria-hidden
                >
                    <path d="M70 5 C 78 5, 78 25, 70 25" />
                </svg>
            </div>
            {showSubtitle && (
                <div className={`mt-1 ${s.sub} uppercase tracking-[0.28em]`}>
                    <span className="text-elegant">by </span>
                    <span className="text-warm font-semibold">renova</span>
                    <span className="text-brand font-semibold ml-0.5">360</span>
                </div>
            )}
        </div>
    );
};

export default Brand;
